export default __webpack_public_path__ + "static/media/agent-chat.3daf5559.svg";